import { Component, Input, OnChanges } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { TabData } from '@ddt-web/data-service';

import { EsgCoverageUtil } from '../utils/esg-coverage.util';

@Component({
	selector: 'esg-coverage',
	templateUrl: './esg-coverage.component.html',
	styleUrls: ['./esg-coverage.component.scss']
})
export class EsgCoverageComponent implements OnChanges {
	@Input() public data: TabData;
	@Input() public coverageDcrKey: string;
	public coverageText: string = '';

	constructor(public contentService: ContentService) { }

	public ngOnChanges(): void {
		this.coverageText = EsgCoverageUtil.generateCoverageText(this.data, this.contentService);
	}
}
